import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=b53d6d6a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b53d6d6a')) {
      api.createRecord('b53d6d6a', component.options)
    } else {
      api.reload('b53d6d6a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=b53d6d6a&", function () {
      api.rerender('b53d6d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tqDhjI8PJise/JS/comp/ImgFallback.vue"
export default component.exports